import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';

import { User } from '../../../../../common/models/main';
import { CacheService } from '../../core/services/cache.service';

@Component({
  selector: 'app-adam',
  templateUrl: './adam.component.html',
  styleUrls: ['./adam.component.scss'],
})
export class AdamComponent implements OnInit {
  user!: User;

  constructor(private cache: CacheService, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {
  }

  async ngOnInit() {
    this.user = await this.cache.getUserPromise();
    await this.handleAdamScript();
  }

  private loadAdamWidget() {
    if (this.user.organization?.integrations.adam.enabled && (window as any).adamftd_embedded) {
      (window as any).adamftd_embedded.load({
        apiKey: 'h5HB6btXIAweIkpwK1IL_VQvT9_p8EdTILLrhCJirrI',
        containerId: 'adamftd-embedded-container-trade-data',
        url: 'https://adamftd.org/public/trade_data',
      });
    }
  }

  private handleAdamScript(): Promise<void> {
    return new Promise(resolve => {
      const scriptId = 'adam-embed-script';
      const existingScript = this.document.getElementById(scriptId);

      if (!this.user.organization?.integrations.adam.enabled) {
        return resolve();
      }

      if (existingScript) {
        if (existingScript.hasAttribute('data-loaded')) {
          this.loadAdamWidget();
          resolve();
        } else {
          existingScript.addEventListener('load', () => {
            this.loadAdamWidget();
            resolve();
          });
          existingScript.addEventListener('error', () => resolve());
        }
        return;
      }

      const script = this.renderer.createElement('script');
      script.id = scriptId;
      script.src = 'https://adamftd.org/cdn/embed.js';
      script.defer = true;
      script.onload = () => {
        script.setAttribute('data-loaded', 'true');
        this.loadAdamWidget();
        resolve();
      };
      script.onerror = () => {
        resolve();
      };
      this.renderer.appendChild(this.document.head, script);
    });
  }
}
